export default "__VITE_ASSET__49a472af__"